import * as React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Root = styled.ul({
  margin: 0,
  padding: 0,
  display: "flex",
  flexDirection: "column",
  gap: 5,
  listStyleType: "none",
});

const ListItem = styled.li({
  display: "flex",
  alignItems: "flex-start",
  gap: 10,
});

function IconList(props) {
  const { className, icon, children, style } = props;
  return (
    <Root
      data-component-name="icon-list"
      className={className}
      style={{ color: style?.textColor }}
    >
      {React.Children.map(children, (child) => (
        <ListItem>
          <div style={{ flexShrink: 0, marginTop: 8 }}>{icon}</div>
          {child}
        </ListItem>
      ))}
    </Root>
  );
}

IconList.propTypes = {
  icon: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  style: PropTypes.shape({
    textColor: PropTypes.string,
  }),
};

export default IconList;
